import { Alert, Badge, Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DifferenceType } from '@modules-deprecated/bankReconciliation/types'

import { Side } from '../../../../../../../../enums/side'
import { useBankTransactionDrawer } from '../../../../contexts'
import { getPaymentDifferenceType } from '../../utils/getPaymentDifferenceType'
import { getTransactionAmount } from '../../utils/getTransactionAmount'
import * as Styled from './styles'

export const DifferenceSelector = (): ReactElement => {
  const { t } = useTranslation()
  const { selectedTransaction, combinedTransactions, difference, differenceType, setDifferenceType, setMatchError } =
    useBankTransactionDrawer()

  const isDebit = selectedTransaction?.side === Side.Debit
  const combinedTotal = selectedTransaction
    ? getTransactionAmount(selectedTransaction, Array.from(combinedTransactions.values()))
    : 0
  const signedCombinedAmount = isDebit ? combinedTotal : -combinedTotal
  const paymentDifferenceType = getPaymentDifferenceType(signedCombinedAmount, difference)
  const couldHaveBankFee = difference < 0

  const handleSelect = (type: DifferenceType) => {
    setDifferenceType(type)
    setMatchError(null)
  }

  return (
    <Styled.Wrapper>
      <Alert variant="error">{t('bank_transactions.drawer.difference_alert')}</Alert>
      <Styled.BadgesContainer>
        <Text weight="medium" variant="bodySM">
          {t('bank_transactions.drawer.select_reason')}
        </Text>
        <Space size="s12" />
        <Flex gap={Spacing.S8} flexWrap="wrap">
          <Badge
            color="warning"
            mode={differenceType === paymentDifferenceType ? 'primary' : 'subtle'}
            size="md"
            onClick={() => handleSelect(paymentDifferenceType)}
            style={{ cursor: 'pointer' }}
          >
            {t(
              paymentDifferenceType === 'overpayment'
                ? 'bank_transactions.drawer.overpayment'
                : 'bank_transactions.drawer.underpayment',
            )}
          </Badge>
          {couldHaveBankFee && (
            <Badge
              color="warning"
              mode={differenceType === 'bankFee' ? 'primary' : 'subtle'}
              size="md"
              onClick={() => handleSelect('bankFee')}
              style={{ cursor: 'pointer' }}
            >
              {t('bank_transactions.drawer.bank_fee')}
            </Badge>
          )}
        </Flex>
      </Styled.BadgesContainer>
    </Styled.Wrapper>
  )
}
